module.exports = __webpack_public_path__ + "static/media/6346.74ea43b7.svg";